// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".payment-element-container[data-v-f2a406be],.stripe-payment-form[data-v-f2a406be]{width:100%}#payment-element[data-v-f2a406be]{min-height:200px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
